import { render, staticRenderFns } from "./VideoBoostOrders.vue?vue&type=template&id=5a2262f4&"
import script from "./VideoBoostOrders.vue?vue&type=script&lang=js&"
export * from "./VideoBoostOrders.vue?vue&type=script&lang=js&"
import style0 from "./VideoBoostOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports